
interface Authorities {  // Priviledge = n, where n=0 can access n+x and x>-1
	HuronAdministrator: boolean;  // Priviledge = 0; all routes.
	CorporationAdministrator: boolean;  // Priviledge = 1; limited routes.
	UserAdministrator: boolean;  // Priviledge =2; limited routes.
	ClientAdministrator: boolean;  // Priviledge =3; limited routes.
	User: boolean;  // Priviledge = 4; purely authenticated users; private.
	None: boolean;  // Priviledge = 5; authenticated or unauthenticated users; public;
}

/**
 * @name: Route-Data
 * @intent:
 * 	* Allow routes to be marked with a tokenized ID to obviate complexity in URL & path recognition.
 * 	* Allow routes to be marked with User-Roles. Each User.roles[i] can be used to key into the RouteDate.roles map.
 * 	*	* If any of User's roles map to a truthy value in RouteData, User can access this route.
 * 	* 	* If none of User's roles map to a truthy value in RouteData.roles, User cannot access this route.
 * @example:
 *  * 	* Route:
 * 	* 	* {
 * 	* 	*	path: 'some/route',
 * 	* 	*	canActivate: [MyGuard],
 * 	* 	*	data: new RouteData({ routeId: 'SOME:ROUTE', roles: { User: true } }),
 * 	* 	* }
 *  * 	*
 *  * 	* "MyGuard" (above):
 * 	* 	* canActivate(route: ActivatedRouteSnapshot) {
 * 	* 	*	if (!route.data) return;
 * 	* 	*	if (!route.data.roles) return;
 * 	* 	*	if (route.data.roles.None) return;
 * 	* 	*	var role = user.roles.find( getAccessRole.bind(this, route.data.roles) );  // returns an item if getAccessRole returns true
 * 	* 	*	var canActivate = !!role;  // if truthy, can; if falsey, cannot.
 * 	* 	*	
 * 	* 	*	function getAccessRole(allowedAuthorities, userRole) {
 * 	* 	*		var value: boolean = allowedAuthorities[ userRole ]
 * 	* 	*		return true;
 * 	* 	*	}
 * 	* 	*	
 * 	* 	*	return canActivate;
 * 	* 	* }
 *  * 	*
 * 
 */
class RouteData {
	routeId: 'LOGIN' | 'LOGOUT' | 'UNAUTHORIZED' | 'CONTACT' | 'LANDING' | 'HOME' | 'ADMIN' | 'STUDER' | 'PROFILE' | '' = '';
	roles: Authorities = { HuronAdministrator: true, CorporationAdministrator: false, UserAdministrator: false, ClientAdministrator: false, User: false, None: false };

	constructor(options: any = {}) {
		this.routeId = options.routeId;
		if(options && options.roles) {
		   this.roles = options.roles;
		}

		return this;
	}	
}

export { RouteData };
